export const mockProducts = [
  {
    id: 1,
    name: 'POS Hardware',
    title: 'Advanced Payment Terminals',
    description: 'NEXGO range of smart terminals featuring the flagship N86 counter-top and newly launched N96. Built with robust hardware and advanced software for secure, reliable and future-ready payment solutions.',
    features: [
      'Android OS for flexibility and scalability',
      'Large colour touchscreens',
      'Quad-core processors (1.6GHz and 2.0GHz)',
      'Long lasting battery life',
      'Fast integrated thermal printer',
      'Waterproof and shockproof design',
      'PCI PTS 6.x certified'
    ],
    image: 'https://customer-assets.emergentagent.com/job_dc63fc88-a4c1-4ec0-a429-62db7388c03c/artifacts/pg86relc_1.jpg',
    route: '/products/pos-card-machines'
  },
  {
    id: 2,
    name: 'TAP and PAY',
    title: 'SoftPOS Solution',
    description: 'Transform any Android device into a fully functional payment terminal. Accept secure contactless transactions directly on a mobile device without additional hardware.',
    features: [
      'No additional hardware required',
      'Works on Android devices (v9.0+)',
      'Contactless payments',
      'Alternative lightweight MPOS device'
    ],
    image: 'https://customer-assets.emergentagent.com/job_dc63fc88-a4c1-4ec0-a429-62db7388c03c/artifacts/rbc7kfki_1.jpg',
    route: '/products/softpos-and-mpos'
  },
  {
    id: 3,
    name: 'EPOS Solutions',
    title: 'Cloud-Based Point of Sale',
    description: 'Next-generation, cloud-based Point of Sale solution combining cutting-edge software and intelligent technology to the heart of hospitality for seamless running of day-to-day operations.',
    features: [
      'Order-taking & payment processing',
      'Quick service & digital menu control',
      'Sales insights & simplified reconciliation',
      'Portable handheld devices'
    ],
    image: 'https://customer-assets.emergentagent.com/job_dc63fc88-a4c1-4ec0-a429-62db7388c03c/artifacts/3hlzlx4s_2.jpg',
    route: '/products/epos-and-mini'
  },
  {
    id: 4,
    name: 'eCommerce',
    title: 'Online Payment Solutions',
    description: 'Flexible online payment options designed for businesses of all sizes. Choose from Direct API integration or Hosted Payment Page solutions.',
    features: [
      'Pay By Link for instant payments',
      'Automate recurring billing',
      'Tokenisation for enhanced security',
      'Direct API or Hosted Payment Page'
    ],
    image: 'https://customer-assets.emergentagent.com/job_3f9e40e3-cca9-4507-83e7-20ced098354a/artifacts/stodeoxq_ALTERNATIVE.png',
    route: '/products/ecommerce-solutions'
  }
];

export const mockFeatures = [
  'Trusted by thousands of businesses',
  'Next-day settlements',
  'Growth tools built-in',
  'Quick set up',
  'Fast transactions',
  'Built for peak times',
  'Human support',
  'Better cashflow',
  'Simple rates',
  'FCA regulated',
  'PCI certified'
];

export const mockSolutions = [
  {
    id: 1,
    title: 'Multi-Channel Processing',
    description: 'Accept payments in-store, online, and mobile with seamless integration across all channels.',
    icon: 'Store'
  },
  {
    id: 2,
    title: 'Advanced Security',
    description: 'PCI PTS 6.x certified terminals with tokenization and fraud prevention built-in.',
    icon: 'Shield'
  },
  {
    id: 3,
    title: 'Real-Time Reporting',
    description: 'Track sales, expenses, and settlements in real-time with comprehensive reporting tools.',
    icon: 'BarChart'
  },
  {
    id: 4,
    title: 'Fast Settlement',
    description: 'Get paid quickly with next-day settlements and instant settlement options available.',
    icon: 'Zap'
  },
  {
    id: 5,
    title: 'Scalable Solutions',
    description: 'From SMEs to enterprise clients, our solutions grow with your business needs.',
    icon: 'TrendingUp'
  },
  {
    id: 6,
    title: 'Dedicated Support',
    description: 'Technical assistance and dedicated account management for peace of mind.',
    icon: 'Headphones'
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: '',
    business: '',
    location: '',
    quote: '',
    image: 'https://customer-assets.emergentagent.com/job_3f9e40e3-cca9-4507-83e7-20ced098354a/artifacts/vbn4mvq3_CARD%201%20-%20REPLACE.jpg',
    type: 'image'
  },
  {
    id: 2,
    name: 'Paul Malone',
    business: 'MPM Event Services Limited, Dublin',
    location: '',
    quote: '\'Our experience with eCOMM Merchant Solutions has been great. The Terminals never let me down. The team is always available and really helpful. I can highly recommend eCOMM to anyone looking for a payments partner.\'',
    image: '',
    type: 'testimonial'
  },
  {
    id: 3,
    name: '',
    business: '',
    location: '',
    quote: '',
    image: 'https://customer-assets.emergentagent.com/job_3f9e40e3-cca9-4507-83e7-20ced098354a/artifacts/fjxl060c_CARD%203.jpg',
    type: 'image'
  },
  {
    id: 4,
    name: 'Eoin O Hagan',
    business: 'Cartmal Range Limited T/A The Acres, Limerick',
    location: '',
    quote: '\'I would recommend eCOMM to any business in any sector. I was beyond surprised when I got introduced to their suite of products. It does everything I need it to do and it\'s so easy to navigate around. The service levels have been immense and they have made it a great experience to date.\'',
    image: '',
    type: 'testimonial'
  },
  {
    id: 5,
    name: '',
    business: '',
    location: '',
    quote: '',
    image: 'https://customer-assets.emergentagent.com/job_3f9e40e3-cca9-4507-83e7-20ced098354a/artifacts/p65o6rf1_CARD%205.jpg',
    type: 'image'
  },
  {
    id: 6,
    name: 'Joan Doorey',
    business: 'Accountant, Mondello Park',
    location: '',
    quote: '\'We\'re extremely happy with the service from eCOMM. Everything works so easily, never any issues. The monthly statements are easy to follow and transparent and they are very helpful whenever we call in.\'',
    image: '',
    type: 'testimonial'
  },
  {
    id: 7,
    name: '',
    business: '',
    location: '',
    quote: '',
    image: 'https://customer-assets.emergentagent.com/job_3f9e40e3-cca9-4507-83e7-20ced098354a/artifacts/cr1o4zkp_CARD%207.jpg',
    type: 'image'
  },
  {
    id: 8,
    name: 'Patricia O\'Neill',
    business: 'Tramore Golf Club',
    location: '',
    quote: '\'We switched to eCOMM on the basis of their rates – they simply offered us the best price. On the occasions that we\'ve wanted support, I spoke with the same person, so there is a personal touch I haven\'t found with other providers.\'',
    image: '',
    type: 'testimonial'
  },
  {
    id: 9,
    name: '',
    business: '',
    location: '',
    quote: '',
    image: 'https://customer-assets.emergentagent.com/job_3f9e40e3-cca9-4507-83e7-20ced098354a/artifacts/mt5sxcky_CARD%209.jpg',
    type: 'image'
  },
  {
    id: 10,
    name: 'Kim Lennon',
    business: 'Salt Cave Paradise, Balbriggan',
    location: '',
    quote: '\'We are really happy with eCOMM\'s Pay By Link Solution. Our customer service reps love this product as it makes their job a lot easier and efficient.\'',
    image: '',
    type: 'testimonial'
  }
];

export const mockStats = [
  { label: 'Active Merchants', value: '5,000+' },
  { label: 'Transactions Processed', value: '50M+' },
  { label: 'Countries Served', value: '2+' },
  { label: 'Years Experience', value: '8+' }
];

export const mockFAQs = [
  {
    id: 1,
    question: 'How Do I Receive My Payments?',
    answer: 'We offer next-day settlements as a standard. Funds are settled directly to your registered bank account.'
  },
  {
    id: 2,
    question: 'How Long Does It Take To Set Up?',
    answer: 'Point of Sale terminals can be delivered same day in special circumstances, with the usual time frame being 24 hours.'
  },
  {
    id: 3,
    question: 'Which Payment Methods Can I Accept?',
    answer: 'All major payment methods including Visa, Mastercard, AMEX, Apple Pay, Google Pay, Samsung Pay, Maestro and Visa Electron.'
  },
  {
    id: 4,
    question: 'Is Your Solution PCI Compliant?',
    answer: 'We are PCI-DSS 4.0.1, Level 1 certified. All our terminals are PCI PTS 6.x certified. We offer many solutions to minimise your compliance burden, including hosted payment pages for eCommerce.'
  },
  {
    id: 5,
    question: 'Do You Offer Integration With Existing Systems?',
    answer: 'Yes, our solutions integrate with over 50 ePOS systems. We also offer bespoke integration services tailored to your specific requirements.'
  },
  {
    id: 6,
    question: 'What Support Do You Provide?',
    answer: 'We provide dedicated technical support and account management. Our customer service team is available to help with any queries or technical issues.'
  }
];
